module.exports = {
  blogPostDir: 'posts', // The name of directory that contains your posts.
  lessonsDir: 'lessons', // The name of the directory that contains lessons or docs.
  siteTitle: 'DMGT Documentation Dev Site', // Site title.
  siteTitleAlt: 'One Documentation site to rule them all', // Alternative site title for SEO.
  siteLogo: '/logos/logo-1024.png', // Logo used for SEO and manifest.
  siteUrl: 'https://www.dmgt.com', // Domain of your website without pathPrefix.
  pathPrefix: '/', // Prefixes all links. For cases when deployed to example.github.io/gatsby-advanced-starter/.
  siteDescription: 'A tutorial site that teaches Flutter and Dart.', // Website description used for RSS feeds/meta description tag.
  siteRss: '/rss.xml', // Path to the RSS file.
  siteFBAppID: '1825356251115265', // FB Application ID for using app insights
  googleAnalyticsID: 'UA-82450300-7', // GA tracking ID.
  disqusShortname: 'flutter-by-example', // Disqus shortname.
  postDefaultCategoryID: 'Tech', // Default category for posts.
  userName: 'User', // Username to display in the author segment.
  userTwitter: 'ericwindmill', // Optionally renders "Follow Me" in the UserInfo segment.
  userLocation: 'Portland, OR', // User location to display in the author segment.
  userAvatar:
    'http://res.cloudinary.com/ericwindmill/image/upload/v1509817350/portfolio_site/no-bg-cartoon.png', // User avatar to display in the author segment.
  userDescription: 'All about me!', // User description to display in the author segment.
  // Links to social profiles/projects you want to display in the author segment/navigation bar.
  github: 'https://github.com/gmorlov',
  twitter: 'https://twitter.com/gmorlov?lang=en',
  email: 'mailto:george.orlov@dmgt.com',
  instagram: '',
  messenger: 'https://www.messenger.com/t/eric.windmill',
  copyright: 'Copyright © 2017. Advanced User', // Copyright string for the footer of the website and RSS feed.
  themeColor: '#c62828', // Used for setting manifest and progress theme colors.
  backgroundColor: '#e0e0e0', // Used for setting manifest background color.
}



// WEBPACK FOOTER //
// ./data/SiteConfig.js